var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useState } from 'react';
import { Modal } from 'src/ui/components/modal/Modal';
import { Select } from 'src/ui/components/Input/Select/Select';
import { Button, EButtonType } from 'src/ui/components/button/Button';
import { COLORS } from 'src/shared/styles/colors';
import { getPropsByKeyPath } from 'src/shared/helpers/objHelpers';
import { getUniqueApplicantLabel, getSmsValueLabel, getEmailValueLabel } from './helpers';
import { ContactChannelCheckbox } from './components/ContactChannelCheckbox/ContactChannelCheckbox';
import styles from './ResendReconnectionLinkModal.module.scss';
export var ResendReconnectionLinkModal = function (props) {
    var _a, _b;
    var i18n = props.i18n, title = props.title, applicants = props.applicants, confirmButton = props.confirmButton, contactChannels = props.contactChannels, isLoading = props.isLoading, onCancel = props.onCancel, onValidate = props.onValidate;
    var _c = useState(false), sendSms = _c[0], setSendSms = _c[1];
    var _d = useState(false), sendEmail = _d[0], setSendEmail = _d[1];
    var _e = useState(0), selectedIndex = _e[0], setSelectedIndex = _e[1];
    var selectedApplicant = applicants[selectedIndex] || applicants[0];
    var selectOptions = applicants.map(function (app, index) { return getUniqueApplicantLabel(app, index, applicants); });
    var selectedName = getUniqueApplicantLabel(selectedApplicant, selectedIndex, applicants);
    var isSmsConfigured = !contactChannels || contactChannels.includes('SMS');
    var isEmailConfigured = !contactChannels || contactChannels.includes('EMAIL');
    // Securely access first cell phone number
    var phone = (selectedApplicant === null || selectedApplicant === void 0 ? void 0 : selectedApplicant.telephone) || ((_b = (_a = selectedApplicant === null || selectedApplicant === void 0 ? void 0 : selectedApplicant.phoneNumbers) === null || _a === void 0 ? void 0 : _a.cells) === null || _b === void 0 ? void 0 : _b[0]);
    var hasPhone = !!phone;
    var hasEmail = !!(selectedApplicant === null || selectedApplicant === void 0 ? void 0 : selectedApplicant.email);
    useEffect(function () {
        if (selectedApplicant) {
            if (isEmailConfigured && hasEmail) {
                setSendEmail(true);
            }
            else if (isSmsConfigured && hasPhone) {
                setSendSms(true);
            }
        }
    }, [selectedApplicant === null || selectedApplicant === void 0 ? void 0 : selectedApplicant.id, isSmsConfigured, isEmailConfigured, hasPhone, hasEmail]);
    // Translation parameters and configuration fallbacks
    var modalTitle = title || getPropsByKeyPath(i18n, 'modules.resendReconnectionLinkModal.title');
    var cancelButtonLabel = getPropsByKeyPath(i18n, 'modules.resendReconnectionLinkModal.cancelButtonLabel');
    var validateButtonLabel = (confirmButton === null || confirmButton === void 0 ? void 0 : confirmButton.label) || getPropsByKeyPath(i18n, 'modules.resendReconnectionLinkModal.confirmButtonLabel');
    var subtitle = getPropsByKeyPath(i18n, 'modules.resendReconnectionLinkModal.subtitle');
    var selectLabel = getPropsByKeyPath(i18n, 'modules.resendReconnectionLinkModal.applicantSelectLabel');
    var smsTitleLabel = getPropsByKeyPath(i18n, 'modules.resendReconnectionLinkModal.smsLabel');
    var emailTitleLabel = getPropsByKeyPath(i18n, 'modules.resendReconnectionLinkModal.emailLabel');
    var smsValueLabel = getSmsValueLabel(hasPhone, phone, i18n);
    var emailValueLabel = getEmailValueLabel(hasEmail, selectedApplicant === null || selectedApplicant === void 0 ? void 0 : selectedApplicant.email, i18n);
    var handleSelectCurrentApplicant = function (newValue) {
        var index = applicants.findIndex(function (app, index) { return getUniqueApplicantLabel(app, index, applicants) === newValue; });
        if (index !== -1) {
            setSelectedIndex(index);
        }
    };
    var handleToggleSms = function () {
        if (hasPhone) {
            setSendSms(function (prev) { return !prev; });
        }
    };
    var handleToggleEmail = function () {
        if (hasEmail) {
            setSendEmail(function (prev) { return !prev; });
        }
    };
    var handleSmsKeyDown = function (e) {
        if (hasPhone && (e.key === ' ' || e.key === 'Enter')) {
            e.preventDefault();
            setSendSms(function (prev) { return !prev; });
        }
    };
    var handleEmailKeyDown = function (e) {
        if (hasEmail && (e.key === ' ' || e.key === 'Enter')) {
            e.preventDefault();
            setSendEmail(function (prev) { return !prev; });
        }
    };
    var handleConfirmSend = function () {
        if (selectedApplicant) {
            onValidate({
                applicantId: selectedApplicant.id,
                sendSms: isSmsConfigured && hasPhone && sendSms,
                sendEmail: isEmailConfigured && hasEmail && sendEmail,
            });
        }
    };
    var isValidateButtonDisabled = (!sendSms && !sendEmail) || isLoading;
    return (_jsxs(Modal, __assign({ title: modalTitle, className: styles.modal, onClose: onCancel, color: COLORS.PRIMARY['500'] }, { children: [_jsxs("div", __assign({ className: styles.componentsWrapper }, { children: [_jsx("p", __assign({ className: styles.smallText }, { children: subtitle })), applicants.length > 1 && (_jsx("div", __assign({ className: styles.selectWrapper }, { children: _jsx(Select, { i18n: i18n, label: selectLabel, options: selectOptions, multiple: false, value: selectedName, onChange: handleSelectCurrentApplicant }) }))), _jsxs("div", __assign({ className: styles.checkboxList }, { children: [isSmsConfigured && (_jsx(ContactChannelCheckbox, { label: smsTitleLabel, value: smsValueLabel, isActive: sendSms, isDisabled: !hasPhone, onToggle: handleToggleSms, onKeyDown: handleSmsKeyDown })), isEmailConfigured && (_jsx(ContactChannelCheckbox, { label: emailTitleLabel, value: emailValueLabel, isActive: sendEmail, isDisabled: !hasEmail, onToggle: handleToggleEmail, onKeyDown: handleEmailKeyDown }))] }))] })), _jsxs("div", __assign({ className: styles.actionsWrapper }, { children: [_jsx(Button, { type: EButtonType.NEUTRAL, isEdge: true, label: cancelButtonLabel, onClick: onCancel }), _jsx(Button, { type: EButtonType.NEUTRAL, label: validateButtonLabel, onClick: handleConfirmSend, disabled: isValidateButtonDisabled, isLoading: isLoading })] }))] })));
};
